var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"main"},[_c('loader',{attrs:{"loading":_vm.$auth.loading || _vm.appLoading}}),_c('v-container',{staticClass:"main-container",attrs:{"fluid":_vm.$route.meta.fluid === true}},[_c('v-row',[_c('v-col',[_vm._t("default")],2)],1)],1),_c('snackbars-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }